import { useQuery } from "@tanstack/react-query";
import { insuredKeys } from "@/queries/insuredKeys";
import { getUserAccess } from "@/services/get-user-access/getUserAccess";
import type { ApiResponseSegcenMap } from "@/interfaces/AccessControl";

export interface UseUserAcessOptions {
  enabled?: boolean;
}

export const useAccessControlUserService = (
  options: UseUserAcessOptions = {}
) => {
  const { enabled = true } = options;

  const accessControlUserQuery = useQuery<ApiResponseSegcenMap | null>({
    queryKey: insuredKeys.all,
    queryFn: () => getUserAccess(),
    enabled: enabled
  });

  return {
    ...accessControlUserQuery
  };
};
